import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTable } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { UserDTO } from "src/app/auth/User";
import { faUserEdit, faUserMinus } from "@fortawesome/free-solid-svg-icons";
import { MatDialog } from "@angular/material/dialog";
import { SessionService } from "src/app/session.service";
import { UsersService } from "../users.service";
import { NotificationService } from "src/app/notifications/notification.service";
import { AvailableAccount } from "src/app/accounts/AvailableAccount";
import { AreYouSureDialogComponent } from "src/app/shared/dialogs/are-you-sure-dialog/are-you-sure-dialog.component";
import { FilterTableDialogComponent } from "src/app/shared/dialogs/filter-table-dialog/filter-table-dialog.component";
import { PermissionService } from "src/app/permission.service";
import { UiService } from "src/app/ui/ui.service";
import { pageSizeOptions } from "src/app/shared/utils/pagination";
import { BehaviorSubject, merge, Observable, of, Subject } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  first,
  switchMap,
  takeUntil,
  tap,
} from "rxjs/operators";
import { DataSource } from "@angular/cdk/table";
import { ElementLoaderDirective } from "src/app/ui/element-loader/element-loader.directive";
import { CollectionViewer } from "@angular/cdk/collections";
import { FormControl } from "@angular/forms";
import { T } from "@angular/cdk/keycodes";
import { LocalStorageService } from "src/app/storage/local-storage.service";
@Component({
  selector: "app-users-list",
  templateUrl: "./users-list.component.html",
  styleUrls: ["./users-list.component.scss"],
})
export class UsersListComponent implements OnInit, AfterViewInit, OnDestroy {
  pageSizeOptions = pageSizeOptions;
  searchValueControl = new FormControl("");
  users!: UserDTO[];
  columns = [
    { code: "last_name", name: "Last Name", filter: true, selected: true },
    { code: "first_name", name: "First Name", filter: true, selected: true },
    { code: "company", name: "Company", filter: true, selected: true },
    { code: "email", name: "Created By", filter: true, selected: true },
    { code: "options" },
  ];
  displayedColumns = this.columns.map((column) => column.code);

  faUserEdit = faUserEdit;
  faUserMinus = faUserMinus;
  @ViewChild("usersTable") usersTable!: MatTable<UserDTO[]>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  showEdit!: boolean;
  showNewUser!: boolean;
  showDelete!: boolean;
  private onComponentDestroy = new Subject();
  @ViewChild(ElementLoaderDirective)
  userElementLoader!: ElementLoaderDirective;
  userDataSource!: UsersDataSource;
  onFilterColumnChange = new Subject();
  perPage: number = 20;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private sessionService: SessionService,
    private usersService: UsersService,
    private notificationService: NotificationService,
    private permissionService: PermissionService,
    private uiService: UiService,
    private ChangeDetectorRef: ChangeDetectorRef,
    private localStorageSvc: LocalStorageService,
  ) {}

  get currentUser(): UserDTO {
    return this.sessionService.currentUserValue!;
  }

  get currentAccount(): AvailableAccount {
    return this.sessionService.currentAccountValue!;
  }

  ngOnInit(): void {
    this.perPage = this.localStorageSvc.pageSize || 20;

    // this.users = this.activatedRoute.snapshot.data.users;
    // this.dataSource = new MatTableDataSource(this.users);

    // this.dataSource.filterPredicate = (data: any, filter: string) => {
    //   let found = false;
    //   for (const column of this.selectedColumns) {
    //     let rowValue = data[column];
    //     if (typeof rowValue === "number") {
    //       rowValue = rowValue.toString();
    //     }
    //     if (rowValue) {
    //       if (rowValue?.trim().toLowerCase().indexOf(filter) !== -1) {
    //         found = true;
    //       }
    //     }
    //   }

    //   return found;
    // };

    Promise.all([
      this.permissionService.categories.users.hasWrite(),
      this.permissionService.categories.users.hasDetail(),
      this.permissionService.categories.users.hasRemove(),
    ]).then(([hasWrite, hasDetail, hasRemove]) => {
      this.showEdit = hasWrite && hasDetail;
      this.showNewUser = hasWrite;
      this.showDelete = hasWrite && hasRemove;
    });
  }

  onPageChange(e: PageEvent){
    this.localStorageSvc.pageSize = e.pageSize;
    this.perPage = e.pageSize;
  }

  ngAfterViewInit() {
    // this.usersTable.renderRows();
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;

    this.userDataSource = new UsersDataSource(
      this.usersService,
      this.paginator,
      this.userElementLoader,
    );

    this.loadUsersPage().pipe(first()).subscribe();

    merge(
      this.sort.sortChange.pipe(tap(() => (this.paginator.pageIndex = 0))),
      this.paginator.page,
      this.onFilterColumnChange,
      this.searchValueControl.valueChanges.pipe(
        distinctUntilChanged(),
        tap(() => (this.paginator.pageIndex = 0)),
      ),
    )
      .pipe(
        debounceTime(300),
        switchMap(() => this.loadUsersPage().pipe(first())),
        takeUntil(this.onComponentDestroy),
      )
      .subscribe();

    this.ChangeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  edit(user: UserDTO) {
    this.router.navigate(["users", user.id, "preferences"]);
  }

  toggleFilterDialog() {
    this.dialog
      .open(FilterTableDialogComponent, {
        data: {
          columns: this.columns,
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.columns = result;
          this.onFilterColumnChange.next();
        }
      });
  }

  delete(user: UserDTO) {
    this.dialog
      .open(AreYouSureDialogComponent, {
        data: {
          areYouSureInfo: {
            description: `Are you sure you want to delete this user ( ${user.email} )?`,
            warning: "Warning: this is not reversible!",
          },
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.uiService
            .waitForEvent(
              this.usersService.deleteUser(this.currentAccount.accountID, user),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(
              () => {
                this.notificationService.openSuccessSnackBar(
                  `Deleted user ${user.email} successfully`,
                );

                this.loadUsersPage().pipe(first()).subscribe();
              },
              (err) => {
                const errorMessage = err.error.message ?? "Error deleting user";
                this.notificationService.openErrorSnackBar(errorMessage);
              },
            );
        }
      });
  }

  // applyFilter() {
  //   this.dataSource.filter = this.searchValue.trim().toLowerCase();

  //   if (this.dataSource.paginator) {
  //     this.dataSource.paginator.firstPage();
  //   }
  // }

  createNewUser() {
    this.router.navigate(["create"], {
      relativeTo: this.activatedRoute.parent,
    });
  }

  loadUsersPage() {
    const sort = this.buildSort();

    return this.userDataSource.loadUsers(
      this.sessionService.currentAccountValue!.accountID,
      {
        page: this.paginator.pageIndex,
        perPage: this.paginator.pageSize,
        keyword: this.searchValueControl.value ?? "",
        forCount: true,
        sort,
        filter_columns: this.columns
          .filter((column) => column.selected)
          .map((column) => column.code),
      },
    );
  }

  buildSort() {
    const sort = [];
    if (this.sort.direction.length) {
      sort.push(`${this.sort.active}:${this.sort.direction}`);
    }
    return sort;
  }
}

export class UsersDataSource implements DataSource<any> {
  private usersSubject = new BehaviorSubject<any[]>([]);

  constructor(
    private UserService: UsersService,
    private paginator: MatPaginator,
    private usersElementLoader: ElementLoaderDirective,
  ) {}

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.usersSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer) {
    this.usersSubject.complete();
  }

  loadUsers(masterAccountID: number, queryParams: any) {
    return this.usersElementLoader
      .waitForEvent(
        this.UserService.getUsers(masterAccountID, queryParams).pipe(
          catchError(() => of({ count: 0, records: [] })),
        ),
      )
      .pipe(
        tap((filter: any) => {
          this.paginator.length = filter.count;
          const records = filter.records;

          this.usersSubject.next(records);
        }),
      );
  }
}
